<div class="container search-form">
  <mat-divider class="divider"></mat-divider>
  <!-- <sha-service-appointment-form [appointment$]="serviceLaneFacade.selectedAppointment$"
    [dropdowns$]="serviceAppointmentDropdowns$" [vehicle]="serviceLaneFacade.vehicle$ | async"
    (appointmentEmitted)="updateAppointment($event, null)"
    (setVerifyCustomerCreateWOButtonEnabled)="setVerifyCustomerCreateWOButtonEnabled($event)">
  </sha-service-appointment-form> -->
</div>
<div class="non-search-form">
  <ng-container *ngIf="caseListView == 'list';else caseView">
    <div fxLayoutAlign="space-between center">
      <h2>Cases</h2>
      <button mat-icon-button color="primary" (click)="caseListView = 'create'">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>
    <sha-appointment-case-list [cases$]="serviceLaneFacade.selectedAppointmentCases$"
      (editCase)="displayEditCase($event)" (caseDeleted)="deleteCase($event)"></sha-appointment-case-list>
  </ng-container>
  <ng-template #caseView>
    <ng-container [ngSwitch]="caseListView">
      <sha-appointment-case-edit-form *ngSwitchCase="'edit'" [case]="caseToEdit"
        [dropdowns$]="serviceLaneDropdownFacade.serviceAppointmentCaseDropdowns$"
        [serviceGroups$]="serviceLaneFacade.serviceGroups$" [vehicle$]="serviceLaneFacade.vehicle$"
        (saveCase)="caseSaved($event)">
      </sha-appointment-case-edit-form>
      <sha-appointment-case-create-form *ngSwitchCase="'create'"
        [dropdowns$]="serviceLaneDropdownFacade.serviceAppointmentCaseDropdowns$"
        [serviceGroups$]="serviceLaneFacade.serviceGroups$" [appointment$]="serviceLaneFacade.selectedAppointment$"
        [vehicle$]="serviceLaneFacade.vehicle$" (createCase)="caseCreated($event)">
      </sha-appointment-case-create-form>
    </ng-container>
  </ng-template>
</div>

<div class="container search-form">
  <div id="quotes" fxLayoutAlign="space-between center">
    <span class="mat-subheading-2">Open Quotes</span>
    <!-- <button mat-icon-button class="secondary" (click)="caseListView = 'create'">
            <mat-icon>add_circle</mat-icon>
          </button> -->
  </div>
  <sha-quote-line-list [lines$]="serviceLaneFacade.quoteLines$" (selectLine)="selectQuoteLine($event)">
  </sha-quote-line-list>
</div>